import { WarningIcon } from 'assets/img/icons/warning';
import React, { Dispatch, SetStateAction } from 'react';
import { Button } from 'components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
} from 'components/ui/dialog';

interface IProps {
  showModal: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  deleteLocation: () => void;
  locationName?: string;
}
const DeleteLocation = ({
  setShowModal,
  showModal,
  deleteLocation,
  locationName,
}: IProps): JSX.Element => {
  return (
    <Dialog open={showModal} onOpenChange={setShowModal}>
      <DialogContent className="max-w-sm" data-testid="delete-location-modal">
        <div className="flex items-start gap-3">
          <WarningIcon viewBox="0 0 32 32" aria-hidden="true" />
          <div>
            <h2 className="mb-2 text-xl font-semibold text-gray-blue-90">Delete location?</h2>
            <span className="text-sm text-gray-blue-70">
              Are you sure you want to delete this{' '}
              <span className="font-semibold"> {locationName} </span>{' '}
              location?
            </span>
          </div>
        </div>
        <DialogFooter className="flex gap-2">
          <Button variant="outline" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button
            data-testid="deleteCTA"
            onClick={() => deleteLocation()}
            variant="destructive"
          >
            Delete location
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteLocation;
